<section class="price-total__container flex row align-center justify-content-between">
  <label class="price-total__label">{{ totalTitle }}</label>
  <div class="flex row align-center">
    <label class="price-total__label">${{ price | number: '1.2-2' }}</label>
    <img class="price-total__info" (click)="infoClicked()" src="assets/images/icons/exclamation-gold.svg" />
  </div>
</section>
